import PropTypes from 'prop-types';
import { forwardRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Collapse from 'shopper/components/Collapse';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import { toLandingPageLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import LANDINGS from 'constants/landings';

const USE_TERMS_TITLE = 'Leia os Termos da Comunidade';
const TOPICS = [
  {
    title: 'Confira se o preço está realmente bom',
    text: " Faça uma busca pelo nome do produto aqui no Promobit e acesse as 'Ofertas Encerradas'. Confira se o preço cobrado está similar ou menor do que aqueles que já apareceram. Não encontrou o produto em nosso histórico? Consulte o Zoom e o Google para saber qual o preço médio dele!\n\n Garantir que o preço está bom aumenta as chances da sua oferta ser aprovada pela moderação!",
  },
  {
    title: 'Evite conteúdo duplicado',
    text: " Às vezes outras pessoas são mais rápidas que nós, por isso confira se já existe uma oferta igual a sua no ar.  Para evitar que sua oferta seja duplicada, faça uma busca pelo nome do produto aqui no Promobit e acesse as 'Ofertas Ativas'.\n\n Garantir que a sua oferta é única aumenta as chances dela ser aprovada pela moderação!",
  },
  {
    title: 'Informe detalhes na descrição',
    text: ' Lembre-se de informar na descrição da oferta detalhes que ajudem outros membros da comunidade a comprar.\n\n Listamos abaixo algumas coisas que podem ser incluídas na descrição das ofertas:\n- Outras formas de pagamento aceitas pela loja;\n- A data de encerramento da promoção;\n- Formas de chegar no preço informado;\n- Dicas para aproveitar melhor a oferta;\n- Sua opinião sobre o produto em promoção.\n\n Incentivamos todos os membros a postarem ofertas com descrições completas para ajudar aqueles que não podem acessar a página do produto (como quem acessa o Promobit no metrô).\n\n Mas não se preocupe! Nenhum desses detalhes é obrigatório.',
  },
  {
    title: USE_TERMS_TITLE,
    text: ' O Promobit tem algumas regras pré-estabelecidas para garantir que:\n- Anunciantes não usem a plataforma para divulgar seus produtos;\n- As opiniões da comunidade não sejam usadas por nenhuma marca ou serviço;\n- Não haja discussões improdutivas na comunidade;\n- As ofertas exibidas no site sejam de qualidade.\n\n É importante estar ciente dessas regras antes de sugerir uma oferta, por isso recomendamos a leitura dos Termos de Uso do Promobit.',
  },
];

const toFormattedTitle = (title, index) => `${index + 1}. ${title}`;

const FormTips = forwardRef(({ className, gaEventCategory, ...rest }, ref) => {
  const [currCollapseOpen, setCurrCollapseOpen] = useState('');

  const onClick = (title) => {
    if (currCollapseOpen) {
      sendEvent({
        action: 'accordion_close',
        category: gaEventCategory,
      });
      setCurrCollapseOpen('');
    }

    if (title !== currCollapseOpen) {
      sendEvent({
        action: 'accordion_open',
        category: gaEventCategory,
      });
      setCurrCollapseOpen(title);
    }
  };

  return (
    <Box ref={ref} className={twMerge('mb-4 p-4', className)} {...rest}>
      <Heading as="h2" className="mb-2" size="size6">
        {placeholder('titles.suggestOfferTips')}
      </Heading>
      <div className="space-y-2">
        {TOPICS.map(({ title, text }, index) => {
          const collapseSharedProps = {
            key: title,
            open: currCollapseOpen === title,
            title: toFormattedTitle(title, index),
            headerProps: { onClick: () => onClick(title) },
          };

          if (title === USE_TERMS_TITLE) {
            return (
              // eslint-disable-next-line react/jsx-key
              <Collapse {...collapseSharedProps}>
                <Text>{text}</Text>
                <Button
                  as="a"
                  className="mt-4"
                  href={toLandingPageLink(
                    'termos',
                    LANDINGS.TYPES.INSTITUTIONAL
                  )}
                  size="size3"
                >
                  {placeholder('actions.seeUseTerms')}
                </Button>
              </Collapse>
            );
          }

          return (
            // eslint-disable-next-line react/jsx-key
            <Collapse {...collapseSharedProps}>
              <Text>{text}</Text>
            </Collapse>
          );
        })}
      </div>
    </Box>
  );
});

FormTips.displayName = 'SuggestNewOfferTips';

FormTips.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default FormTips;
